<mat-dialog-title style="padding: 8px 12px;">
  <button class="close-icon" mat-icon-button mat-dialog-close>
    <mat-icon mat-dialog-close>close</mat-icon>
  </button>
</mat-dialog-title>

<mat-dialog-content class="dialog-container">
  <p>Your address could not be found. Do you wish to proceed with this address:</p>
  <p class="label">{{address}}</p>
  <div class="actions">
    <button class="button-Secondary" (click)="close(false)">Cancel</button>
    <button class="button-Primary" (click)="close(true)">Confirm</button>
  </div>
</mat-dialog-content>